import { NavLink } from "react-router-dom";

const TABS = [
  { to: "/manufacturing/orders", label: "Orders", testid: "mfg-tab-orders" },
  { to: "/manufacturing/boms", label: "BOMs", testid: "mfg-tab-boms" },
  { to: "/manufacturing/lots", label: "Lots", testid: "mfg-tab-lots" },
];

export default function MfgTabs() {
  return (
    <div className="flex gap-1 border-b border-border" data-testid="manufacturing-tabs">
      {TABS.map((t) => (
        <NavLink key={t.to} to={t.to} data-testid={t.testid}
          className={({ isActive }) =>
            `px-4 py-2 text-sm font-semibold border-b-2 -mb-px transition-colors ${isActive ? "border-[#EB1C27] text-[#002B5D]" : "border-transparent text-slate-500 hover:text-slate-800"}`
          }>
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}
